import React from 'react';
import Helmet from 'react-helmet';

import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';

import '@app/scss/pages/privacyPolicy.scss';

const PrivacyPolicy: React.FC = () => {
	return <div className="container privacy-policy">
		<ServerPageProvider path="privacy-policy" defaultTitle="Privacy Policy" loader={<></>} inner={(s) => <></>} />
		<h1>ONLINE PRIVACY POLICY</h1>
		<h4>Updated on November 2, 2021</h4>
		<p className="privacy-policy__text">
			Northern Tuna recognizes the importance of protecting the privacy of your information.
			This statement reviews our policies and procedures for protecting your private information.
			The Site is an Internet property of Northern Tuna ("Northern Tuna," “NT”, "we," "our" or "us").
			The following Northern Tuna Privacy Policy ("Privacy Policy") sets forth our policy with respect
			to the collection, storage and use of your personal information and other information that we collect
			from you solely online via our website, software, telemedicine and any website and application,
			product or service including, without limitation,
			<a target="_blank" href="https://northerntuna.com/" rel="noreferrer">&nbsp;www.NorthernTuna.com</a>
			, and
			<a target="_blank" href="https://portal.northerntuna.com/" rel="noreferrer">&nbsp;www.Portal.NorthernTuna.com</a>
			,
			and any other website, application or online service that links to or refers to this Privacy Policy.
		</p>
		<p className="privacy-policy__text">
			Please note that our practice complies with the requirements of the Health Insurance Portability
			and Accountability Act of 1996 (HIPAA) with information collected online and in person. Users with
			disabilities who wish to access this Privacy Policy in an alternative format can contact us by emailing
			us at: support@northerntuna.com.
		</p>
		<h3 className="privacy-policy__subtitle">
			Personal Information
		</h3>
		<p className="privacy-policy__text">
			We collect personal data when you access certain of the Site Offerings and complete the required
			information request Form and/or otherwise provide such information to us. The information that each
			User must supply on the applicable form may include, without limitation: (a) the User’s name; (b) the
			User’s mailing/billing address; (c) the User’s e-mail address; (d) the User’s telephone number; (e) the
			User’s credit card information (where purchasing products, using telemedicine, or making deposits);
			(f) the User’s designated emergency contact and associated contact information; (g) username and password;
			(h) information about your employment, such as job title, practice area, primary specialty, and medical
			license status, gender, date of birth, languages spoken, educational background, address, photograph, social
			security number, Tax ID, NPI number, professional license information and bank account information; (i)
			personal information about patient’s diagnosis, previous treatments, general health, health insurance and
			information in which you or the patients have stored in NorthernTuna.com; (j) any other information
			requested on the form.
		</p>
		<h3 className="privacy-policy__subtitle">
			How Personal Information Is Used
		</h3>
		<p className="privacy-policy__text" style={{ marginBottom: 0 }}>
			Other than if compelled through legal processes; or it is discovered that your use of our website violates
			any laws or usage practices; or if the information is required to finalize a payment for services and
			products requested, Northern Tuna will never share, sell, rent, exchange or barter your personal information
			to or with any third party for financial gain or marketing purposes.
		</p>
		<p className="privacy-policy__text">
			Further, by making your personal information available to Northern Tuna you grant Northern Tuna the right,
			subject to applicable law, to use that personal information to contact you regarding your use of the site
			offerings (including to provide you with requested price quotes and/or the newsletter) and/or with
			information regarding other Northern Tuna products and/or services that we think may be of interest to you.
			If you wish to stop receiving future communications from us, please follow the instructions at the end of
			each such e-mail message or see the "Opt-Out/Unsubscribe" section.
		</p>
		<p className="privacy-policy__text">
			Where you submit personal information, we use the personal information that you make available to
			personalize your experience with the Site and to facilitate the provision of the applicable Site Offerings
			to you, including in connection with customer service and to otherwise respond to any inquiries made by you.
		</p>
		<p className="privacy-policy__text">
			You also agree that we may contact you at any time with updates and/or any other information that we may
			deem appropriate for you to receive in connection with your continued use of the Site Offerings.

		</p>
		<p className="privacy-policy__text">
			Information may also be used to send reminders of future appointments you have scheduled with Northern Tuna.
			All information you provide is treated as private and confidential.
		</p>
		<p className="privacy-policy__text">
			We may also use your personal information for internal business purposes, such as analyzing and managing our
			service offerings including, without limitation, all information collected through the Site Offerings. We
			may also combine the information we have gathered about you with information from other sources.
		</p>
		<p className="privacy-policy__text">
			By submitting your personal information by and through the Site Offerings,
			you agree that such act constitutes an inquiry and/or application for purposes of the Amended Telemarketing
			Sales Rule (16 CFR §310 et seq.), as amended from time to time (the "Rule") and applicable state do-not-call
			regulations. As such, notwithstanding that your telephone number may be listed on the Federal Trade
			Commission’s Do-Not-Call List, and/or on applicable state do-not-call lists, we retain the right to contact
			you via telemarketing in accordance with the Rule and applicable state do-not-call regulations.
		</p>
		<h3 className="privacy-policy__subtitle">
			Disclosure to Third Parties
		</h3>
		<p className="privacy-policy__text">
			We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information.
			This does not include trusted third parties who assist us in the operation of our website, conducting our
			business, or servicing you, in which case these people/entities are under a signed agreement to not misuse
			or disclose information. We may also release your information when we believe such release is required to
			comply with the federal, state, or local laws, enforce our site policies, or protect ours or others’ rights,
			property, or safety. However, non-personally identifiable visitor information may be provided to other
			parties for marketing or other uses.
		</p>
		<h3 className="privacy-policy__subtitle">
			Cookies
		</h3>
		<p className="privacy-policy__text">
			When a User visits the Site, we send one (1) or more cookies and/or gif files (collectively, "Cookies") to
			assign an anonymous, unique identifier to the applicable User’s computer. A cookie is a piece of data stored
			on your hard drive containing non-personally identifiable information about you. Cookies have many benefits
			to enhance your experience at the site. We use cookies to improve the quality of the Site Offerings,
			including for storing User preferences and tracking Site-User trends (such as pages opened and length of
			stay at the Site).
		</p>
		<p className="privacy-policy__text">
			Most Internet browsers are initially set up to accept cookies, but you can reset your browser to refuse all
			cookies or to indicate when a cookie is being sent. To disable and reject certain cookies, follow the
			instructions associated with your Internet browser. Even in the case where a User rejects a cookie, she or
			he may still use the Site Offerings; provided, however, that certain Site Offerings-related functions may be
			impaired or rendered inoperable if the use of Cookies is disabled. We reserve the right to retain cookie
			data indefinitely.
		</p>
		<h3 className="privacy-policy__subtitle">
			Behavioral Tracking
		</h3>
		<p className="privacy-policy__text">
			Northern Tuna as well as third party entities such as Google® (using the "Google Analytics" tool), use
			Cookies, pixels and other tracking technology (collectively, "Tracking Technology") in connection with the
			Site for purposes of tracking Users’ activities (such as websites visited, advertisements selected and pages
			viewed) after they leave the Site. Northern Tuna and its third-party partners use this Tracking Technology
			to target applicable Users with advertisements featuring Northern Tuna products and/or services, as well as
			third-party products and/or services, that may be of interest to applicable Users.
		</p>
		<p className="privacy-policy__text">
			Google’s® ability to use and share information collected by Google® Analytics about your visits to and use
			of the Site is restricted by the Google® Analytics Terms of Service, available here, and the Google Privacy
			Policy, available here. You may learn more about how Google® collects and processes data specifically in
			connection with Google® Analytics here. You may prevent your data from being used by Google® Analytics by
			downloading and installing the Google Analytics Opt-out Browser Add-on, available here.
		</p>
		<p className="privacy-policy__text">
			In general, Users may also be able to disable some, or all, of this tracking activity by utilizing the "Do
			Not Track" setting or similar options within most major Internet browsers. In addition, Users may be able to
			opt-out of this form of tracking utilizing the options made available by the Network Advertising Initiative
			or Digital Advertising Alliance.
		</p>
		<h3 className="privacy-policy__subtitle">
			Third Party Links
		</h3>
		<p className="privacy-policy__text">
			This Site may contain links to third-party owned and/or operated websites including, without limitation, the
			Social Media Websites and the websites of the Third-Party Travel Service Providers and Third-Party Insurance
			Providers. Northern Tuna is not responsible for the privacy practices or the content of such websites. In
			some cases, you may be able to make a purchase through one of these third-party websites. In these
			instances, you may be required to provide certain information, such as a credit card number, to register or
			complete a transaction at such website. These third-party websites have separate privacy and data collection
			practices and Northern Tuna has no responsibility or liability relating to them.
		</p>
		<h3 className="privacy-policy__subtitle">
			Data Security & Information Access
		</h3>
		<p className="privacy-policy__text">
			Databases are regularly backed up and saved to protect against loss of information. Backup storage media and
			online servers are maintained in a physically secured and environmentally controlled facility with monitored
			physical access controlled by password, biometric and physical security measures.
		</p>
		<p className="privacy-policy__text">
			Access to visitor or guest information (including backup media) by staff and contractors is controlled by
			both policy and electronic means. Only authorized staff has access to customer data. Individual staff
			members may be allowed to access only certain parts of customer information as may be required to perform
			their job functions. All staff or contractors with any access to customer data are under a signed agreement
			not to misuse or disclose such information to any third party except as may be required by law or job
			function.
		</p>
		<p className="privacy-policy__text">
			We reserve the right to modify this privacy policy at any time without notice.
		</p>
		<h3 className="privacy-policy__subtitle">
			Contact Information
		</h3>
		<p className="privacy-policy__text">
			If you have any questions or comments about this Privacy Notice, our Privacy Policy, the ways in which we
			collect and use your personal information, your choices and rights regarding such use, please do not
			hesitate to contact us by emailing us at: support@northerntuna.com.
		</p>
	</div>;
};

export default PrivacyPolicy;
